<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Author, Clive Towle, born in 1939 a few months before the beginning of WW2 shares his life-time memories with the readers. This is a full and very lively story covering many good, and not so good aspects of life. But with honesty and belief in himself.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?590987b5